import * as React from 'react'

import { useBgColorCtx } from '~theme/BgColorProvider'
import { TColorKey, TContrastLevel } from '~theme/typings'
import { getColorValue } from '~theme/utils'
import { useTheme } from '~ui/theme/ThemeProvider'

export type TSvgProps = React.SVGProps<SVGSVGElement>
export type TNoColorSvgProps = Omit<TSvgProps, 'fill' | 'color'>

type TProps = NoChildren &
  TNoColorSvgProps & {
    /**
     * React component, that accepts `React.SVGProps<SVGSVGElement>` and returns some `svg`
     */
    component: React.FC<NoChildren & TSvgProps>
    /**
     * the color of the logo, one of the project color keys,
     * if not defined, the color is automatically calculated based on the background color
     */
    color?: TColorKey
    /**
     * how contrasted the svg should be on said background
     */
    contrast?: TContrastLevel
  }

/**
 * `svg` wrapper with automatic color selection (based on the consumed bgColor context & the required `contrast`)
 */
export const Svg: React.FC<TProps> = ({
  color,
  contrast = `normal`,
  component: Component,
  ...svgProps
}) => {
  const theme = useTheme()
  const { fgColors } = useBgColorCtx()

  const colorValue = color ? getColorValue(theme)(color) : fgColors[contrast]

  return <Component {...svgProps} fill={colorValue} />
}
